 https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
 ( function () {
     'use strict';
     jQuery.extend( true, e4.settings, {
         intersectionObserver: {
             options: {
                 root: null,
                 rootMargin: '0px',
                 threshold: 0
             }
         },
         require: {
             timeout: 3000,
             handlebars: {
                 url: '/files/system/espresso/design/_assets/js/vendor/handlebars.min.js',
                 fallback: '//cdnjs.cloudflare.com/ajax/libs/handlebars.js/4.0.11/handlebars.min.js',
                 callback: null // Register helper and compile templates
             }
         },         
         ecom: {
             pdfmakeUrl: {
                 url: '/files/templates/designs/sika/_assets/js/vendor/pdfmake.js',
                 fallback: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.62/pdfmake.js',
                 callback: null
             },
             vfsfontsUrl: {
                 url: '/files/templates/designs/sika/_assets/js/vendor/vfs_fonts.js',
                 fallback: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.62/vfs_fonts.js',
                 callback: null
             },
             productListWithFacets: {
                 showParamsInUrl: true,
                 feedUrl: '/system/data/facetsv2',
                 lazyLoad: {
                     /* buttonShowInterval: 0 = once, 1 = every page, 2, 3, 4, n = n time */
                     buttonShowInterval: 2,
                     /* autoLoadCount: If total product count is less than this - no load more button */
                     autoLoadCount: 10,
                     observerOptions: {
                         /* root: null = viewport */
                         root: null,
                         /* rootMargin: px or pct only */
                         rootMargin: '50% 0px 50% 0px',
                         threshold: 0
                     }
                 },
             },
         }
     } );
 }() );
